export const getInvitationsPrefix = (attemptsRemained) => (attemptsRemained && attemptsRemained > 1 ? 's' : '');
